export default __webpack_public_path__ + "static/media/oscer-pres-eye-pain.8665cdfe.svg";